import { render } from "./ClauseItem.vue?vue&type=template&id=c3d2ea9a&scoped=true"
import script from "./ClauseItem.vue?vue&type=script&lang=js"
export * from "./ClauseItem.vue?vue&type=script&lang=js"

import "./ClauseItem.vue?vue&type=style&index=0&id=c3d2ea9a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3d2ea9a"]])

export default __exports__